import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Aguardando análise" },
    { value: 2, label: "Concluída" },
    { value: 4, label: "Arquivada" }
];

const SituacaoConsulta = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoConsulta, options as OpcoesSituacaoConsulta }